import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createGraphqlWsClient } from "./graphqlWsClient";

const authWsClient = createGraphqlWsClient({
  wsEnvUrl: process.env.REACT_APP_WS_AUTH_BFF_URL,
  httpEnvUrl: process.env.REACT_APP_REST_AUTH_BFF_URL,
});

const authWSLink = authWsClient ? new GraphQLWsLink(authWsClient) : null;

export default authWSLink;
